<div class="not-found-container">
  <div class="not-found-header">
    <span>404</span>
  </div>
  <div class="not-found-title"><span>{{'text_oops' | dbText}}</span></div>
  <div class="not-found-desc"><span>{{'text_pageNotFound' | dbText}}</span></div>
  <div class="not-found__button-wrap" *ngIf="showGoHomeButton">
    <a class="db-button db-button_info" [routerLink]="['/websites']" ><span>{{'text_goHome' | dbText}}</span></a>
  </div>
</div>
<db-loading-screen [ngClass]="{'hidden':!loading}" [pageBlocker]="true"></db-loading-screen>
